import axiosInstance from "./axiosInstance";

interface IUploadFile {
  file: File;
}

export interface IUploadFileResponse {
  status: number;
  data?: {
    type: string;
    fileLink: string;
    name: string;
  };
}

const UploadFile = async ({
  file,
}: IUploadFile): Promise<IUploadFileResponse> => {
  try {
    let formData = new FormData();
    formData.append("fileData", file);

    const response = await axiosInstance.post("/file/upload", formData);

    if (response.status === 200) {
      return {
        status: 200,
        data: { fileLink: response.data.key, name: file.name, type: "files" },
      };
    }

    return { status: 500 };
  } catch (error) {
    console.log(error);
    return { status: 500 };
  }
};

export default UploadFile;
